import React, { useState, useEffect, useCallback } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Checkbox,
    Grid,
    TextField,
    IconButton,
    Typography,
    Box,
    Divider
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { VendorLookup } from './VendorLookup';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import { toast } from 'react-toastify';

export default function MultiCompanyVendorLookup(props) {
    const { open, onClose, vendorCode, vendorMap = {}, onConfirm, mode = mode, inProgress, getUserMappedValues } = props;
    var { currentCompanyCode } = props;

    const [companyList, setCompanyList] = useState([]);
    const [selectedCompanies, setSelectedCompanies] = useState({});
    const [vendorLookupTarget, setVendorLookupTarget] = useState(null);
    const [vendorLookupOpenStates, setVendorLookupOpenStates] = useState({});
    const [confirmOpen, setConfirmOpen] = useState(false);

    const userInfo = JSON.parse(localStorage.userInfo || '{}');
    const resourceId = userInfo.id;
    if (!currentCompanyCode) {
        currentCompanyCode = userInfo.companyCode;
    }
    //let loginUserRole = userInfo.selectedUserRoles.userRoleId;


    //const matchVendorsToCompanies = (companies, vendorMap) => {
    //    const updatedSelection = {};
    //    companies.forEach(company => {
    //        const vendors = vendorMap[company.companyCode] || [];
    //        const matchedVendor = vendors.find(v => v.vendorCode === props.vendorCode);
    //        updatedSelection[company.companyCode] = {
    //            selected: false,
    //            vendor: matchedVendor?.vendorCode || ''
    //        };
    //    });
    //    setSelectedCompanies(updatedSelection);
    //};

    useEffect(() => {
        if (open && companyList.length > 0 && vendorCode) {
            const updatedSelection = {};
            companyList.forEach((company) => {
                updatedSelection[company.companyCode] = {
                    selected: true,
                    vendor: company.vendorCode || '',
                    vendorName: company.vendorName || '',
                    companyName: company.coName || ''
                };
            });
            setSelectedCompanies(updatedSelection);
        }
    }, [open, companyList, vendorCode]);



    const fetchCompanyListWithVendorMatch = useCallback(() => {
        props.inProgress(true);
        const uri = `/api/lookup/companyvendor?resourceId=${encodeURIComponent(resourceId)}&vendorCode=${encodeURIComponent(props.vendorCode)}`;
        httpGet(uri)
            .then((response) => {
                const data = Array.isArray(response.data) ? response.data : [];
                const companies = data.filter(c => c.companyCode !== currentCompanyCode);
                companies.sort((a, b) => a.coName.localeCompare(b.coName));
                const selectionMap = {};
                companies.forEach(c => {
                    selectionMap[c.companyCode] = {
                        selected: false,
                        vendor: c.vendorCode || '',
                        companyName: c.coName || '',
                        vendorName: c.vendorName || ''
                    };
                });
                setSelectedCompanies(selectionMap);
                setCompanyList(companies);
                props.inProgress(false);
            })
            .catch((err) => {
                console.error('Failed to load company/vendor matches', err);
                props.inProgress(false);
            });
    }, [currentCompanyCode, props.vendorCode]);


    useEffect(() => {
        if (currentCompanyCode != undefined && props.vendorCode != null) {
            fetchCompanyListWithVendorMatch();
        }
    }, [currentCompanyCode, props.vendorCode]);

    //useEffect(() => {
    //    if (props.vendorCode) {
    //        matchVendorsToCompanies(companyList, allCompanyVendors);
    //    }
    //}, [props.vendorCode]);

    const handleCheckboxChange = (companyCode) => (event) => {
        const company = companyList.find(c => c.companyCode === companyCode);
        setSelectedCompanies(prev => ({
            ...prev,
            [companyCode]: {
                ...prev[companyCode],
                selected: event.target.checked,
                companyName: company?.coName || '',
                vendorName: company?.vendorName || '',
                vendor: event.target.checked ? prev[companyCode].vendor : ''
            }
        }));
    };

    const handleVendorChange = (companyCode) => (event) => {
        setSelectedCompanies(prev => ({
            ...prev,
            [companyCode]: {
                ...prev[companyCode],
                vendor: event.target.value,
                selected: true
            }
        }));
    };

    const handleOpenVendorLookup = (companyCode) => () => {
        setVendorLookupTarget(companyCode);
        setVendorLookupOpenStates(prev => ({ ...prev, [companyCode]: true }));
    };

    const handleVendorLookupClose = (event, selectedVendor) => {
        if (selectedVendor && vendorLookupTarget) {
            setSelectedCompanies(prev => ({
                ...prev,
                [vendorLookupTarget]: {
                    ...prev[vendorLookupTarget],
                    vendor: selectedVendor.vendorCode,
                    vendorName: selectedVendor.vendorName,
                    selected: true
                }
            }));
        }
        setVendorLookupOpenStates(prev => ({ ...prev, [vendorLookupTarget]: false }));
        setVendorLookupTarget(null);
    };

    const handleConfirm = () => {
        const hasMissingVendors = Object.entries(selectedCompanies).some(
            ([_, data]) => data.selected && !data.vendor
        );

        if (hasMissingVendors) {
            toast.error("Please select a vendor for all selected companies.");
            return;
        }

        const selectedMappings = Object.entries(selectedCompanies)
            .filter(([_, data]) => data.selected && data.vendor);

        if (selectedMappings.length === 0) {
            const baseMapping = getUserMappedValues();
            baseMapping.vendorCompanyLists = [];
            onConfirm(baseMapping);
            return;
        }
        else {
            setConfirmOpen(true);
        }
    };


    const handleConfirmMapping = () => {
        let selectedMappings = [];
        let hasError = false;

        for (const [companyCode, data] of Object.entries(selectedCompanies)) {
            if (data.selected) {
                if (!data.vendor) {
                    hasError = true;
                    break;
                }
                selectedMappings.push({
                    companyCode: parseInt(companyCode),
                    companyName: data.companyName,
                    vendorCode: data.vendor,
                    vendorName: data.vendorName
                });
            }
        }

        if (hasError) {
            toast.error("Please select a vendor for all selected companies.");
            return;
        }
        
        const baseMapping = getUserMappedValues();
        baseMapping.vendorCompanyLists = selectedMappings;
        setConfirmOpen(false);

        onConfirm(baseMapping);
    };

    const allSelected =
        companyList.length > 0 &&
        companyList.every(
            c => selectedCompanies[c.companyCode]?.selected
        );

    const handleSelectAllChange = (event) => {
        const checked = event.target.checked;

        setSelectedCompanies(prev => {
            const updated = { ...prev };
            companyList.forEach(company => {
                updated[company.companyCode] = {
                    ...updated[company.companyCode],
                    selected: checked,
                    vendor: checked ? updated[company.companyCode]?.vendor : ''
                };
            });
            return updated;
        });
    };

    const formattedMode = mode.replace("to Create", "").trim();


    return (
        <>
            <Dialog open={open} fullWidth maxWidth="md">
                <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                        Select Companies {mode}
                        {/*<Typography variant="caption">/Vendor Mapping</Typography>*/}
                    </Box>
                    <IconButton onClick={onClose}><CloseIcon /></IconButton>
                </DialogTitle>
                <DialogContent>
                    {/*<Typography variant="body2" sx={{ mb: 2, color: 'primary.main' }}>*/}
                    {/*    Select one or more companies where this {mode.toLowerCase()} should also be created. Use the vendor lookup to assign the correct vendor for each selected company. The system will copy the mapping and associated PDF file to each selected company(s).*/}
                    {/*</Typography>*/}
                    <Grid container spacing={1} alignItems="center" sx={{ fontWeight: 'bold', pb: 1 }}>
                        <Grid item xs={1}>
                            <Checkbox
                                checked={allSelected}
                                indeterminate={
                                    !allSelected &&
                                    Object.values(selectedCompanies).some(v => v?.selected)
                                }
                                onChange={handleSelectAllChange}
                            />
                        </Grid>
                        <Grid item xs={6}>Company</Grid>
                        <Grid item xs={5}>Vendor</Grid>
                    </Grid>
                    <Divider sx={{ mb: 1 }} />
                    {companyList.map((company) => (
                        <React.Fragment key={company.companyCode}>
                            <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                <Grid item xs={1}>
                                    <Checkbox
                                        checked={selectedCompanies[company.companyCode]?.selected || false}
                                        onChange={handleCheckboxChange(company.companyCode)}
                                    />
                                </Grid>
                                <Grid item xs={5}>{company.coName}</Grid>
                                <Grid item xs={6}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        value={
                                            selectedCompanies[company.companyCode]?.vendor
                                                ? `${selectedCompanies[company.companyCode]?.vendor} - ${selectedCompanies[company.companyCode]?.vendorName}`
                                                : ''
                                        }
                                        onChange={handleVendorChange(company.companyCode)}
                                        placeholder="Select Vendor"
                                        InputProps={{
                                            endAdornment: (
                                                <IconButton size="small" onClick={handleOpenVendorLookup(company.companyCode)}
                                                    //disabled={!selectedCompanies[company.companyCode]?.selected}
                                                >
                                                    <SearchIcon fontSize="small" />
                                                </IconButton>
                                            ),
                                            sx: {
                                                color: 'black',
                                            }
                                        }}
                                        className={`${selectedCompanies[company.companyCode]?.selected && !selectedCompanies[company.companyCode]?.vendor ? 'border-red' : ''}`}
                                        disabled={true}
                                        sx={{
                                            '& .MuiInputBase-input.Mui-disabled': {
                                                WebkitTextFillColor: '#3d3d3d',
                                            }
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Divider sx={{ mb: 1 }} />
                            <VendorLookup
                                info={{
                                    openDialog: vendorLookupOpenStates[company.companyCode] || false,
                                    source: 'vendorsitemapping',
                                    inProgress: props.inProgress,
                                    invoiceModel: {
                                        currencyCode: company.currencyCode,
                                        companyCode: company.companyCode,
                                        vendorCode: selectedCompanies[company.companyCode]?.vendor || ''
                                    },
                                }}
                                onClose={handleVendorLookupClose}
                            />
                        </React.Fragment>
                    ))}
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2 }}>
                    <Button onClick={onClose} variant="outlined" color="primary">
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleConfirm} color="primary">
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={confirmOpen} fullWidth maxWidth="sm">
                <DialogTitle>Confirm Mapping Creation</DialogTitle>
                <DialogContent>
                    <Typography>
                        {formattedMode} will be created in all selected companies. Please click OK to continue.
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleConfirmMapping} color="primary">
                        OK
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

